<div fxFlex class="generic-chart-container sound-button widget-bg">
  <leplace-polar-chart *ngIf="init" [data]="polarData" [options]="chartOptions" (action)="onSelect($event)"
    class="sound-chart"></leplace-polar-chart>
</div>